// tao 1 file chua setting dang nhap

export const USER_LOGIN = 'USER_LOGIN';
export const DOMAIN = 'https://movie0706.cybersoft.edu.vn';
export const ACCESSTOKEN = 'ACCESSTOKEN';